import { fileNameHasDate } from './fileNameHasDate';
import { buildDateString } from './buildDateString';

const serveCSV = (reportLines, title, delimiter = ',') => {
    let reportString = Array.isArray(reportLines)
        ? reportLines
            // Normalize non-printable whitespace by converting to spaces. For example, NNBSP(u+202f) just becomes ' '.
              // eslint-disable-next-line no-control-regex
              .map((v) =>
                  v.map((v) => `"${typeof v === 'string' ? v.trim().replace(/\s/g, ' ') : ''}"`).join(delimiter)
              )
              .join('\n')
        : reportLines;
    const fileName = fileNameHasDate(title) ? title : `${title}_${buildDateString()}`;
    const element = document.createElement('a');

    element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(reportString));
    element.setAttribute('download', `${fileName}.csv`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

export default serveCSV;
